export enum CardBrandEnum {
  MASTERCARD = 'Mastercard',
  VISA = 'Visa',
  AMEX = 'Amex',
  ELO = 'Elo',
  HIPERCARD = 'Hipercard',
  UNKNOWN = 'Unknown',
}
